import React, { FunctionComponent } from "react";

import { useGetVehicleInfo } from "../../../queries/useGetVehicleInfo";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { CartButton } from "../../Cart/CartButton/CartButton";
import { usePricing } from "../../PriceSelect/usePricing";
import { partIsStaggered } from "../Results/Filters/TireSizeFilters/partIsStaggered";
import { useTireResults } from "../Results/useTireResults";
import { gridCellClass } from "./TireComparisonGrid";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
};

export const AddToQuote: FunctionComponent<ProductInfoProps> = ({ part }) => {
  const isStaggered = partIsStaggered(part);
  const { entries } = usePricing({
    defaultQuantity: isStaggered ? "2" : "4",
    isStaggered,
    part: part,
  });
  const { data: results } = useTireResults();
  const { data: vehicleInfo } = useGetVehicleInfo();
  const [primaryPriceOption] = entries;

  if (!primaryPriceOption || !useShouldRenderPricing(part)) {
    return null;
  }
  const [combinedPart, pricingOption] = primaryPriceOption;
  return (
    <div className={gridCellClass}>
      <CartButton
        className="md:h-12 w-full"
        createPackageClassName="md:h-12 w-full ring-amber-300 bg-opacity-100 mt-2 border border-edge bg-paper"
        isStaggered={isStaggered}
        part={part}
        pricing={[{ combinedPart, pricingOption }]}
        primary
        vehicleId={results?.resultParameters.vehicleId || null}
        vehicleInfo={vehicleInfo || null}
      />
    </div>
  );
};
